<template>
    <v-main>
        <head>
            <title>Create a new Measurement - Foraje</title>
            <meta name="description" content="A form to allow you to create a new measurement, to track whatever it is you wish">
        </head>
        <div v-if="issomethingloading && !cropitems.length">
            <v-container>
                <v-row  >
                    <v-col cols="12" class="text-center">
                        <v-progress-circular
                                :size="100"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
            <v-dialog v-model="cropquickcreatedialog" max-width="750px" persistent>
            <CropQuickCreate v-on:close-dialog="cropquickcreatedialog = false" v-on:crop-created="CropSuccessfullyCreated">
            </CropQuickCreate>
            </v-dialog>
            <form @submit.prevent="CompleteMeasurementSubmission">
            <v-container>
                <v-card>
                    <v-col cols="12" class="text-center">
                            <h1>Submit a new crop measurement</h1>
                    </v-col>
                <v-row  >
                    <v-col cols="12" class="text-center">
                        <h2>Measurement Basics</h2>
                    </v-col>
                    <v-col cols="12" sm="8" class="MeasurementFormField">
                        <v-text-field
                                v-model="name"
                                label="Name to store this measurement with"
                                counter="200"

                        >

                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" class="MeasurementFormField">
                        <v-autocomplete
                                v-model="selectedtrial"
                                :items="trialitems"
                                item-text="name"
                                return-object
                                :loading="aretrialsloading"
                                label="Which of your trials is this measurement a part of?"
                        >

                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="8" class="MeasurementFormField">
                        <v-autocomplete
                        v-model="selectedcrop"
                        :items="cropitems"
                        return-object
                        item-text="name"
                        :loading="arecropsloading"
                        label="Which of your crops are you measuring?*"
                        @input="GetAvailableVarietyComponents"
                        required
                        >

                        </v-autocomplete>

                    </v-col>
                    <v-col cols="12" class="hidden-sm-and-up pb-4">
                        <v-btn
                                dark
                                small
                                color="green"
                                @click="cropquickcreatedialog = true"
                        >
                            Create a New Crop
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col md="2" class="hidden-xs-only pl-2">
                        <v-btn
                                dark
                                fab
                                small
                                color="green"
                                @click="cropquickcreatedialog = true"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="8" class="MeasurementFormField">
                        <v-autocomplete
                                v-model="selectedcomponent"
                                :items="availablevarietycomponents"
                                :loading="arevarietycomponentsloading"
                                item-text="name"
                                return-object
                                label="Which part are you measuring?*"
                                required
                        >

                        </v-autocomplete>
                    </v-col>
                        <v-col cols="12" sm="8" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="measurementtype"
                                    :items="measurementtypeitems"
                                    label="What type of measurement is this?*"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                </v-row>
                    <v-row   v-if="measurementtype==='Size'">
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="size.length"
                                    label="Length"
                                    type="number"
                                    min="0"
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selectedsizeunit"
                                    :items="sizeunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="size.width"
                                    label="Width"
                                    type="number"
                                    min="0"
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selectedsizeunit"
                                    :items="sizeunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="size.height"
                                    label="Height"
                                    type="number"
                                    min="0"
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selectedsizeunit"
                                    :items="sizeunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Diameter'">
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="diameter"
                                    label="Diameter"
                                    type="number"
                                    min="0"
                                    required
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selecteddiameterunit"
                                    :items="sizeunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Weight'">
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="weight"
                                    label="Weight"
                                    hint="How much does this weigh?"
                                    type="number"
                                    min="0"
                                    required
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selectedweightunit"
                                    :items="weightunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Volume'">
                        <v-col cols="10" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="volume"
                                    label="Volume"
                                    hint="What's the volume of this?"
                                    type="number"
                                    min="0"
                                    required
                                    step="any"
                            >

                            </v-text-field>
                        </v-col>
                        <v-col cols="2" class="MeasurementFormField">
                            <v-autocomplete
                                    v-model="selectedvolumeunit"
                                    :items="volumeunits"
                                    label="Units"
                                    required
                            >

                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Count'">
                        <v-col cols="12" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="count"
                                    label="Count"
                                    type="number"
                                    min="0"
                                    step="1"
                                    hint="Whole numbers (Positive Integers) only, decimals will be rounded up."
                                    required

                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='pH'">
                        <v-col cols="12" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="ph"
                                    label="pH"
                                    hint="Two decimal places max. 7 is okay, as is 7.02, but 7.022 will just be rounded to 7.02"
                                    type="number"
                                    min="-1"
                                    max="16"
                                    step=".01"
                                    placeholder="7.00"
                                    required

                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Color'">
                        <v-col cols="12" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="color"
                                    label="Color"
                                    required
                            >

                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row   v-if="measurementtype==='Other'">
                        <v-col cols="12" sm="8" class="MeasurementFormField">
                            <v-text-field
                                    v-model="other"
                                    label="Other"
                                    required
                            >

                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                <v-row>
                <v-spacer></v-spacer>
                    <v-col cols="12">

                    </v-col>
                </v-row>
                <v-card>
                <v-row  >
                    <v-col cols="12" class="text-center">
                        <h2>Measurement Extras</h2>
                    </v-col>
                    <v-col cols="12" sm="8" class="MeasurementFormField">
                        <v-menu
                                :close-on-content-click="false"
                                v-model="datepickermenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <v-text-field
                                    slot="activator"
                                    v-model="measurementdate"
                                    color="primary"
                                    label="Measurement Date"
                                    hint="When was this measurement performed?"
                                    persistent-hint
                                    prepend-icon="event"
                                    readonly
                            ></v-text-field>
                            <v-date-picker v-model="measurementdate" @input="datepickermenu = false">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="8" class="MeasurementFormField" v-if="measurementdate">
                        <v-menu
                                :close-on-content-click="false"
                                v-model="timepickermenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <v-text-field
                                    slot="activator"
                                    v-model="measurementtime"
                                    color="primary"
                                    label="Measurement Time*"
                                    hint="At what time was this measurement performed?"
                                    persistent-hint
                                    prepend-icon="access_time"
                                    readonly
                                    @change="$v.measurementtime.$touch()"
                                    @blur="$v.measurementtime.$touch()"
                                    :error-messages="measurementtimeErrors"
                            ></v-text-field>
                            <v-time-picker v-model="measurementtime" @input="timepickermenu = false" ampm-in-title>
                            </v-time-picker>
                        </v-menu>
<!--                        <p class="error" v-if="!$v.measurementtime.required">this field is required</p>-->
                    </v-col>
                    <v-col cols="12" sm="10" class="MeasurementFormField">
                        <v-textarea
                                v-model="usernotes"
                                label="Notes"
                                hint="Any notes for yourself about the measurement you'd like to save"
                        >

                        </v-textarea>
                    </v-col>
                </v-row>
                </v-card>
            </v-container>
                <v-col cols="4" offset="5">
                    <v-btn>
                        Cancel
                    </v-btn>
                    <v-btn type="submit" :loading="measurementsubmitloading" color="primary">
                        Submit
                        <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                    </v-btn>
                </v-col>
            </form>
        </div>
    </v-main>
</template>

<script>
import axios from 'axios';
import {
  required, between, decimal, integer,
} from 'vuelidate/lib/validators';
import CropQuickCreate from '../../crops/CropQuickCreate.vue';

export default {
  name: 'NewVarietyComponentMeasurement',
  components: { CropQuickCreate },
  data: () => ({
    name: '',

    aretrialsloading: false,
    trialitems: [],
    selectedtrial: [],


    arecropsloading: false,
    cropitems: [],
    selectedcrop: [],
    selectedcropdetails: [],

    arevarietycomponentsloading: false,
    availablevarietycomponents: [],
    selectedcomponent: [],

    subcomponentitems: [],
    subcomponent: '',

    measurementtypeitems: ['Size', 'Diameter', 'Weight', 'Volume', 'Count', 'pH', 'Color', 'Other'],
    measurementtype: '',

    datepickermenu: false,
    measurementdate: '',

    timepickermenu: false,
    measurementtime: '',

    sizeunits: ['meters', 'centimeters', 'millimeters', 'feet', 'inches'],
    selectedsizeunit: '',


    size: {
      length: 0,
      width: 0,
      height: 0,
    },

    diameter: '',
    selecteddiameterunit: '',

    weightunits: ['grams', 'kilograms', 'pounds', 'ounces'],
    selectedweightunit: '',
    weight: '',

    volumeunits: ['liters', 'milliliters', 'gallon', 'pint', 'ounce', 'cubic foot', 'cubic meter'],
    selectedvolumeunit: '',
    volume: '',

    color: '',

    count: '',

    ph: '',

    other: '',

    secondaryunits: '',

    usernotes: '',

    measurementsubmitloading: false,

    cropquickcreatedialog: false,


  }),
  validations: {
    ph: {
      between: between(-1, 16),
      decimal,

    },

    count: {
      integer,
    },
    measurementtime: {
      required,
    },
  },
  methods: {
    GetThisUsersTrials() {
      this.aretrialsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('barebones/filtered/measurements/trial/by/submitter/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.trialitems = response.data;
        })
        .then(() => {
          this.aretrialsloading = false;
        });
    },
    GetThisUsersCrops() {
      this.arecropsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('basics/table/crop/by/producer/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.cropitems = response.data;
        })
        .then(() => {
          this.arecropsloading = false;
        });
    },

    GetAvailableVarietyComponents() {
      this.arevarietycomponentsloading = true;
      this.availablevarietycomponents = [];
      this.selectedcomponent = [];
      const varietytocheck = this.selectedcrop.variety.id;

      return axios.get(`barebones/filtered/component/by/variety/${varietytocheck}/`)
        .then((response) => {
          this.availablevarietycomponents = response.data;
        })
        .then(() => {
          this.arevarietycomponentsloading = false;
        });
    },
    SubmitMeasurementImage() {

    },
    ResetAllData() {
      this.selectedcrop = [];
      this.selectedcropdetails = [];
      this.selectedcomponent = [];
      this.measurementtype = '';
      this.measurementdate = '';
      this.measurementtime = '';
      this.selectedsizeunit = '';
      this.size = {
        length: 0,
        width: 0,
        height: 0,
      };
    },

    SubmitParentMeasurement() {
      const authheader = `Token ${this.$store.getters.token}`;
      const measurementdata = this.removeEmptyStrings({
        name: this.name,
        date_time: this.convertedmeasurementdatetime,
        component: this.selectedcomponent.id,
        crop: this.selectedcrop.id,
        user_note: this.usernotes,
        trial: this.selectedtrial.id,
      });
      return axios.post('forms/measurements/component/parent/create/', measurementdata,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .catch(() => {
          this.$parent.$emit('alertemitted', {
            alert_icon: 'far fa-frown',
            alert_color: 'error',
            alert_message: 'Something broke, probably our bad. The error should have been '
                                + "recorded by our system, so we'll try and fix it.",
          });
        });
    },
    SubmitNewQuantitativeMeasurement(parentmeasurement, measurementtypetosubmit) {
      const authheader = `Token ${this.$store.getters.token}`;
      const measurementdata = this.removeEmptyStrings({
        type: measurementtypetosubmit,
        quantitative_value: this.quantitativevalue(measurementtypetosubmit),
        units: this.trueunits,
        user_submission: this.rawsubmission(measurementtypetosubmit),
        raw_user_submission: this.rawsubmission(measurementtypetosubmit),
        user_selected_units: this.selectedunits,
        parent_measurement: parentmeasurement,
      });
      return axios.post('forms/measurements/component/quantitative/create/', measurementdata,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .catch(() => {
          this.$parent.$emit('alertemitted', {
            alert_icon: 'far fa-frown',
            alert_color: 'error',
            alert_message: 'Something broke, probably our bad. The error should have been '
                                + "recorded by our system, so we'll try and fix it.",
          });
        });
    },
    SubmitNewQualitativeMeasurement(parentmeasurement, measurementtypetosubmit) {
      const authheader = `Token ${this.$store.getters.token}`;
      const measurementdata = this.removeEmptyStrings({
        type: measurementtypetosubmit,
        qualitative_value: this.qualitativevalue,
        parent_measurement: parentmeasurement,
      });
      return axios.post('forms/measurements/component/qualitative/create/', measurementdata,
        {
          headers: {
            Authorization: authheader,
          },
        })
        .catch(() => {
          this.$parent.$emit('alertemitted', {
            alert_icon: 'far fa-frown',
            alert_color: 'error',
            alert_message: 'Something broke, probably our bad. The error should have been '
                                + "recorded by our system, so we'll try and fix it.",
          });
        });
    },
    CompleteMeasurementSubmission() {
      this.measurementsubmitloading = true;
      this.$v.$touch();
      if (!this.formincomplete) {
        this.SubmitParentMeasurement()
          .then((response) => {
            const parentmeasurement = response.data.id;
            if (this.measurementcategory === 'quantitative') {
              this.adjustedtype.forEach(type => this.SubmitNewQuantitativeMeasurement(parentmeasurement, type));
            } else if (this.measurementcategory === 'qualitative') {
              this.adjustedtype.forEach(type => this.SubmitNewQualitativeMeasurement(parentmeasurement, type));
            }
          })

          .then(() => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'check_circle',
              alert_color: 'success',
              alert_message: 'Measurement Recorded!',
            });
          })
          .then(() => {
            this.measurementsubmitloading = false;
          })
          .then(() => {
            this.$router.push('/');
          })

          .catch((e) => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'far fa-frown',
              alert_color: 'error',
              alert_message: 'Something broke, probably our bad. The error should have been '
                                    + "recorded by our system, so we'll try and fix it.",
            });
            console.log(e);
          });
      } else this.measurementsubmitloading = false;
    },

    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') {
          newObj[prop] = obj[prop];
        }
      });
      return newObj;
    },
    convertedsizevalue(sizemeasurement) {
      if (this.selectedsizeunit === 'meters') {
        return this.size[sizemeasurement];
      } if (this.selectedsizeunit === 'centimeters') {
        return this.size[sizemeasurement] / 100;
      } if (this.selectedsizeunit === 'millimeters') {
        return this.size[sizemeasurement] / 1000;
      } if (this.selectedsizeunit === 'feet') {
        return this.size[sizemeasurement] * 0.3048;
      } if (this.selectedsizeunit === 'inches') {
        return this.size[sizemeasurement] / 39.37;
      } return NaN;
    },
    converteddiametervalue(sizemeasurement) {
      if (this.selectedsizeunit === 'meters') {
        return this.size[sizemeasurement];
      } if (this.selectedsizeunit === 'centimeters') {
        return this.size[sizemeasurement] / 100;
      } if (this.selectedsizeunit === 'millimeters') {
        return this.size[sizemeasurement] / 1000;
      } if (this.selectedsizeunit === 'feet') {
        return this.size[sizemeasurement] * 0.3048;
      } if (this.selectedsizeunit === 'inches') {
        return this.size[sizemeasurement] / 39.37;
      } return NaN;
    },

    convertedweightvalue() {
      if (this.selectedweightunit === 'kilograms') {
        return this.weight;
      } if (this.selectedweightunit === 'grams') {
        return this.weight / 1000;
      } if (this.selectedweightunit === 'pounds') {
        return this.weight / 2.20462234;
      } if (this.selectedweightunit === 'ounces') {
        return this.weight * 0.02834952312;
      } return NaN;
    },
    convertedvolumevalue() {
      if (this.selectedvolumeunit === 'liters') {
        return this.volume;
      } if (this.selectedvolumeunit === 'milliliters') {
        return this.volume / 1000;
      } if (this.selectedvolumeunit === 'gallon') {
        return this.volume * 3.785411784;
      } if (this.selectedvolumeunit === 'pint') {
        return this.volume * 0.473176473;
      } if (this.selectedvolumeunit === 'ounce') {
        return this.volume * 0.0295735295625;
      } if (this.selectedvolumeunit === 'cubic foot') {
        return this.volume * 28.316846592;
      } if (this.selectedvolumeunit === 'cubic meter') {
        return this.volume * 1000;
      } return NaN;
    },
    quantitativevalue(sizemeasurement) {
      if (this.measurementtype === 'Size') {
        return Number(this.convertedsizevalue(sizemeasurement)).toFixed(12);
      } if (this.measurementtype === 'Diameter') {
        return Number(this.converteddiametervalue(sizemeasurement)).toFixed(12);
      } if (this.measurementtype === 'Weight') {
        return Number(this.convertedweightvalue()).toFixed(12);
      } if (this.measurementtype === 'Volume') {
        return Number(this.convertedvolumevalue()).toFixed(12);
      } if (this.measurementtype === 'Count') {
        return parseInt(this.count, 10).toFixed(0);
      } if (this.measurementtype === 'pH') {
        return parseFloat(this.ph).toFixed(2);
      } return NaN;
    },
    rawsubmission(sizemeasurement) {
      if (this.measurementtype === 'Size') {
        return this.size[sizemeasurement];
      } if (this.measurementtype === 'Diameter') {
        return this.diameter;
      } if (this.measurementtype === 'Weight') {
        return this.weight;
      } if (this.measurementtype === 'Volume') {
        return this.volume;
      } if (this.measurementtype === 'Count') {
        return this.count;
      } if (this.measurementtype === 'pH') {
        return this.ph;
      } return null;
    },
    CropSuccessfullyCreated() {
      this.cropquickcreatedialog = false;
      this.GetThisUsersCrops();
    },


  },

  created() {
    this.GetThisUsersCrops();
    this.GetThisUsersTrials();
  },

  computed: {

    convertedmeasurementdatetime() {
      if (this.measurementtime) {
        const combineddatetime = `${this.measurementdate} ${this.measurementtime}`;
        return new Date(combineddatetime);
      } if (this.measurementdate) {
        return new Date(this.measurementdate);
      } return '';
    },

    trueunits() {
      if (this.measurementtype === 'Size') {
        return 'meters';
      } if (this.measurementtype === 'Diameter') {
        return 'meters';
      } if (this.measurementtype === 'Weight') {
        return 'kilograms';
      } if (this.measurementtype === 'Volume') {
        return 'litres';
      } if (this.measurementtype === 'Count') {
        return 'count';
      } if (this.measurementtype === 'pH') {
        return 'ph';
      } return 'unknown';
    },
    selectedunits() {
      if (this.measurementtype === 'Size') {
        return this.selectedsizeunit;
      } if (this.measurementtype === 'Diameter') {
        return this.selecteddiameterunit;
      } if (this.measurementtype === 'Weight') {
        return this.selectedweightunit;
      } if (this.measurementtype === 'Volume') {
        return this.selectedvolumeunit;
      } if (this.measurementtype === 'Count') {
        return 'count';
      } if (this.measurementtype === 'pH') {
        return 'ph';
      } return 'unknown';
    },
    qualitativevalue() {
      if (this.color) {
        return this.color;
      } if (this.other) {
        return this.other;
      } return null;
    },
    adjustedtype() {
      if (this.measurementtype === 'Size') {
        return ['length', 'width', 'height'];
      } if (this.measurementtype === 'Diameter') {
        return ['diameter'];
      } if (this.measurementtype === 'Weight') {
        return ['weight'];
      } if (this.measurementtype === 'Volume') {
        return ['volume'];
      } if (this.measurementtype === 'Count') {
        return ['count'];
      } if (this.measurementtype === 'pH') {
        return ['ph'];
      } if (this.measurementtype === 'Color') {
        return ['color'];
      } if (this.measurementtype === 'Other') {
        return ['other'];
      } return ['unknown'];
    },
    measurementcategory() {
      if (this.measurementtype === 'Size'
                    || this.measurementtype === 'Diameter'
                    || this.measurementtype === 'Weight'
                    || this.measurementtype === 'Volume'
                    || this.measurementtype === 'Count'
                    || this.measurementtype === 'pH') {
        return 'quantitative';
      }
      if (this.measurementtype === 'Color'
                    || this.measurementtype === 'Other') {
        return 'qualitative';
      } return 'unknown';
    },

    // Despite the name, doesn't check if the form is incomplete, just if measurementtime is complete.
    formincomplete() {
      return !!(this.measurementdate && !this.measurementtime);
    },
    measurementtimeErrors() {
      const errors = [];
      if (!this.$v.measurementtime.$dirty) return errors;
      if (!this.$v.measurementtime.required) { errors.push('Required. Must select a measurement time.'); }
      return errors;
    },

  },
};
</script>

<style scoped>
    .MeasurementFormField{
        padding: 10px;
    }

</style>
